import React, { useEffect, useState } from 'react'
import CountriesCities from "../../assets/icons/projects icons/country.png"
import { ADMIN_PAGE_LABELS } from "../../navigation/adminNavigation"
import projectIcon from "../../assets/icons/projects icons/project.png"
import { deleteDataToken, getData, patchDataToken, postData } from '../../axios/axiosHelper';
import toast from 'react-hot-toast';


const CountriesAndCities = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [countryEn, setCountryEn] = useState(null)
    const [countryAr, setCountryAr] = useState(null)
    const [selectedTeamId, setSelectedTeamId] = useState(null);
    const [selectedTeamName, setSelectedTeamName] = useState(null);
    const [loadingAddCountry, setLoadingAddCountry] = useState(false)
    const [laoding, setLaoding] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [totalPages, setTotalPages] = useState(1);
    const [allCountries, setAllCountries] = useState([])
    const [search, setSearch] = useState("")
    const [cities, setCities] = useState([{ nameEn: '', nameAr: '' }]);
    const [showEditCity, setShowEditCity] = useState(false);
    const [onecity, setOnecity] = useState({})
    const [cityNameEnEdit, setCityNameEnEdit] = useState(null)
    const [cityNameArEdit, setCityNameArEdit] = useState(null)
    const handleCloseEditCity = () => setShowEditCity(false);
    const handleShowEditCity = () => setShowEditCity(true);
    const [deletecityFromCountryLoading, setDeletecityFromCountryLoading] = useState({})
    const [deleteCountryLoading, setDeleteCountryLoading] = useState({})
    const [countryID, setCountryID] = useState(null)
    const [editcityLoading, seteditcityLoading] = useState(false)
    const [oneCountry, setOneCountry] = useState({})
    const [showEditCountry, setShowEditCountry] = useState(false);
    const handleCloseEditCountry = () => setShowEditCountry(false);
    const handleShowEditCountry = () => setShowEditCountry(true);
    const [countryNameEnEdit, setcountryNameEnEdit] = useState(null)
    const [countryNameArEdit, setcountryNameArEdit] = useState(null)
  const [loadingAddGovernorate, setLoadingAddGovernorate] = useState(false);
  const [governorateEn, setGovernorateEn] = useState(null);
  const [governorateAr, setGovernorateAr] = useState(null);
    const [showAddGovernorate, setShowAddGovernorate] = useState(false);
    const handleShowAddGovernorate = () => setShowAddGovernorate(true);
    const handleCloseAddGovernorate = () => setShowAddGovernorate(false);

    const NavItems = [
      { name: ADMIN_PAGE_LABELS.countriesCities, to: "/projects/countriescities", icon: CountriesCities },
      // { name: "Banner", to: "/banner", icon: projectIcon },
    ];


    const handleInputChange = (index, field, value) => {
      const updatedCities = [...cities];
      updatedCities[index][field] = value;
      setCities(updatedCities);
    };
  
    const addNewCity = () => {
      setCities([...cities, { nameEn: '', nameAr: '' }]);
    };
  
    const handleClickAddGovernorate = async () => {

      handleShowAddGovernorate();
    };
  
    const deleteCity = (index) => {
      const updatedCities = cities.filter((_, i) => i !== index);
      setCities(updatedCities);
    };


    const handleAddNewCountry = (e) => {
      e.preventDefault()
      setLoadingAddCountry(true)
      let arRegex = /^[0-9\u0600-\u06FF\s]+$/;
      if (!arRegex.test(countryAr)) {
         toast.error("Please Enter An Arabic country Name Correct");
        setLoadingAddCountry(false);
      }else{
        postData("/country" , {
          "nameEn": countryEn,
          "nameAr": countryAr,
          "governorates":cities
      } , true).then(response => {
        handleClose()
        setCities([{ nameEn: '', nameAr: '' }])
        setCountryAr(null)
        setCountryEn(null)
        handleClose()
        getAllCountries(currentPage, itemsPerPage,search)
        toast.success(response?.data?.message)
      }).catch(err => {
        toast.error(err?.response?.data?.message)
      }).finally(()=>{
        setLoadingAddCountry(false)
      })
      }
  
}
      
      const getAllCountries = (page = 1, perPage = 5,search) => {
        setLaoding(true)
        getData(`/country?page=${page}&perPage=${perPage}&search=${search}` , true).then(response => {
        setAllCountries(response?.data?.data)
        setTotalPages(response?.data?.pagination?.totalPages || 1);
        }).catch(err => {
          toast.error(err?.response?.data?.message)
        }).finally(()=>{
          setLaoding(false)
        })
      }

      useEffect(()=>{
        getAllCountries(currentPage, itemsPerPage,search)
      },[currentPage, itemsPerPage,search])

      
      const getPageNumbers = () => {
        const pages = [];
        const startPage = Math.max(1, currentPage - 1);
        const endPage = Math.min(totalPages, startPage + 2);
        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
        return pages;
      };
      
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  
  const deletecityFromCountry = async (id) => {
    setDeletecityFromCountryLoading((prevState) => ({ ...prevState, [id]: true }))
    deleteDataToken(`/governorate/${id}`).then(response => {
      toast.success(response?.data?.message);
      getAllCountries(currentPage, itemsPerPage,search);
    }).catch(err => {
      toast.error(err?.response?.data?.message)
    }).finally(()=>{
    setDeletecityFromCountryLoading((prevState) => ({ ...prevState, [id]: false }))
    })
  }




  const handleclickEditCity = async (data) => {
    setOnecity(data)
    setCityNameEnEdit(data.nameEn)
    setCityNameArEdit(data.nameAr)
    handleShowEditCity()
  }




  const submitEditCity = async (e) => {
    seteditcityLoading(true)
    e.preventDefault()
    patchDataToken(`/governorate/${onecity._id}` , {
      "nameEn": cityNameEnEdit,
      "nameAr": cityNameArEdit,
      "country": countryID
  } , true  ).then(response => {
    toast.success(response?.data?.message)
    handleCloseEditCity()
    getAllCountries(currentPage, itemsPerPage,search);
  }).catch(err => {
    toast.error(err?.response?.data?.message)
  }).finally(()=>{
    seteditcityLoading(false)
  })
  }


  const deleteCountry = async (id) => {
    setDeleteCountryLoading((prevState) => ({ ...prevState, [id]: true }))
    deleteDataToken(`/country/${id}`).then(response => {
      toast.success(response?.data?.message);
      getAllCountries(currentPage, itemsPerPage,search);
    }).catch(err => {
      toast.error(err?.response?.data?.message)
    }).finally(()=>{
      setDeleteCountryLoading((prevState) => ({ ...prevState, [id]: false }))
    })
  }






  const handleclickEditcountry = async (data) => {
    setOneCountry(data);
    setcountryNameEnEdit(data.nameEn);
    setcountryNameArEdit(data.nameAr);
    handleShowEditCountry();
  }

  const [countryEditLoading, setCountryEditLoading] = useState(false)

  const onSubmitEditCountry = async (e) => {
      e.preventDefault()
      setCountryEditLoading(true)
      patchDataToken(`/country/${oneCountry._id}` , {
        "nameEn": countryNameEnEdit,
        "nameAr": countryNameArEdit
    } , true).then(response => {
    toast.success(response?.data?.message)
      handleCloseEditCountry()
      getAllCountries(currentPage, itemsPerPage,search);
    }).catch(err => {
      toast.error(err?.response?.data?.message)
    }).finally(()=>{
      setCountryEditLoading(false)
    })
  }
 const handleAddNewGovernorate = (e) => {
    e.preventDefault();
    setLoadingAddGovernorate(true);

    postData(
      "/governorate",
      {
        nameEn: governorateEn,
        nameAr: governorateAr,
        country: countryID,
      },
      true
    )
      .then((response) => {
       
        setGovernorateAr(null);
        setGovernorateEn(null);
        handleCloseAddGovernorate();
        getAllCountries(currentPage, itemsPerPage, search);
        toast.success(response?.data?.message);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setLoadingAddGovernorate(false);
      });
  };
      
      return {
        NavItems,
        deleteCountry,
        setSearch,
        handleShow,
        show,
        handleInputChange,
        cities,
        deleteCity,
        handleClose,
        addNewCity,
        selectedTeamName,
        setCountryEn,
        setCountryAr,
        handleAddNewCountry,
        loadingAddCountry,
        allCountries,
        handlePageChange,
        currentPage,
        totalPages,
        getPageNumbers,
        deletecityFromCountry,
        handleclickEditCity,
        setCountryID,
        deletecityFromCountryLoading,
        showEditCity,
        handleCloseEditCity,
        submitEditCity,
        setCityNameEnEdit,
        setCityNameArEdit,
        cityNameArEdit,
        editcityLoading,
        cityNameEnEdit,
        deleteCountryLoading,
        handleclickEditcountry,
        showEditCountry,
        handleCloseEditCountry,
        setcountryNameEnEdit,
        countryNameEnEdit,
        setcountryNameArEdit,
        countryNameArEdit,
        onSubmitEditCountry,
        countryEditLoading,
        laoding,
        handleClickAddGovernorate,
        handleAddNewGovernorate,
        loadingAddGovernorate,
        showAddGovernorate,
        setGovernorateEn,
        setGovernorateAr,
        handleCloseAddGovernorate
      }
    }
  
  


export default CountriesAndCities
